import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import Header from '../../../components/Header';
import Footer from '../../../components/Footer/Footer';
import { Form, Button } from 'react-bootstrap';
import { Axios } from 'axios';

const Login = (e) => {
	const [password, setPassword] = useState('');
	let navigate = useNavigate();

	const handleLogin = () => {
		if (password === 'hyundaimma') {
			navigate('/smart-inspect/montgomery/overview');
		}
	};

	return (
		<>
			<Header plant="montgomery" login />
			<main>
				<wrapper class="section-wrapper">
					<container class="section-container" id="login">
						<Form onSubmit={handleLogin}>
							<h2>Login</h2>

							<Form.Group className="mb-3">
								<Form.Label>Password</Form.Label>
								<Form.Control type="password" placeholder="Enter password" value={password} onChange={(event) => setPassword(event.target.value)} />
							</Form.Group>

							<Form.Group>
								<Button variant="primary" type="submit" style={{ display: 'block', margin: '0 auto' }}>
									Submit
								</Button>
							</Form.Group>
						</Form>
					</container>
				</wrapper>
				<Footer />
			</main>
		</>
	);
};

export default Login;
